export const WASTE_REASONS = strings => ({
  expired: strings.expired,
  damaged: strings.damaged,
  quality: strings.quality
})
